import { createContext } from "react";

export const ActiveRouteContext = createContext();

export const CurrentPageContext = createContext(); // for public pages only

export const PageResourceLoaderContext = createContext(); // for private authenticated pages only.